import type { ViewQueryMultiTablePivot } from '../../../../schemas/query/index.ts'
import type { ViewConfigPivot } from '../../../../schemas/view_config/index.ts'

export function generateNodeFromDimension(
  pivot: ViewConfigPivot,
  depth: number,
  parentNodeNames: string[],
): ViewQueryMultiTablePivot['tree'] {
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if ((pivot.rows ?? []).length === 0) {
    return {
      // eslint-disable-next-line sonarjs/todo-tag
      // TODO: 不要な要素が多いので、型を見直したい
      name: `valuesNode`,
      path: [...parentNodeNames, `valuesNode`],
      read: {
        tableSql: '',
        tableSqlTransparency: 'opaque',
        tableType: 'table',
        idColumn: '',
      },
      meta: {
        label: '',
        dependedStreamNames: [],
      },
    }
  }

  const name = `dimensionNode${depth}`
  return {
    // eslint-disable-next-line sonarjs/todo-tag
    // TODO: 不要な要素が多いので、型を見直したい
    name,
    path: [...parentNodeNames, name],
    read: {
      tableSql: '',
      tableSqlTransparency: 'opaque',
      tableType: 'table',
      idColumn: '',
    },
    meta: {
      label: '',
      dependedStreamNames: [],
    },
    children: [
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
      generateNodeFromDimension({ rows: (pivot.rows ?? []).slice(1), columns: pivot.columns ?? [] }, depth + 1, [
        ...parentNodeNames,
        name,
      ]),
    ],
  }
}
